import React, { useState, useEffect } from "react";
import AddnExport from "../sub-components/Add-Export";
import DataTable from "react-data-table-component";
import { ActivePill, InactivePill } from "../sub-components/StatusPill";
import { useNavigate } from "react-router-dom";
import Search from "../sub-components/Search";
import TableActions from "../sub-components/TableActions";
import { StockService } from "../../../../services/StockService";
import moment from "moment";
import swal from "sweetalert";
import toast from "react-hot-toast";
const Products = () => {
  const navigate=useNavigate()
  const productColumns = [
    {
      name: "Name",
      selector: (row) => row.productName,
    },
    {
      name: "Description",
      selector: (row) => row.description,
    },
    {
      name: "Price",
      selector: (row) => `GHS ${row.price}.00`,
    },
    {
      name: "Quantity In Stock",
      selector: (row) => row.quantityInStock,
    },

    {
      name: "Active",
      selector: (row) => row.isActive?<ActivePill >Active</ActivePill>:<InactivePill>Inactive</InactivePill>,
    },
    {
      name: "Date",
      selector: (row) => moment(row.dateCreated).format('yyyy-MM-DD'),
    },
    {
      name:'Actions',
      selector:(row)=><div>
        <TableActions viewAction={()=>navigate(`${row.productId}`)} deleteAction={()=>deleteRow(row)} />
      </div>
    }
  
  ];

  const [pending, setPending] = useState(true);
  const [products,setProducts] = useState([])
  const deleteRow = (row) => {
    swal({
      title: "Delete this product?",
      text: `${row.productName} will be removed permanently. The server refuses if orders, waybills or returns still use it.`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((confirmed) => {
      if (!confirmed) return;
      StockService.RemoveProduct(row.productId).then((res) => {
        if (res.Successful) {
          toast.success(res.message || "Product deleted");
          setProducts((rows) => rows.filter((r) => r.productId !== row.productId));
        } else {
          toast.error(res.message, { duration: 8000 });
        }
      });
    });
  };
 
  useEffect(() => {
    handleProducts();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

   

    const handleProducts = () => {
      StockService.GetAllProducts().then((res) => {
        
        setProducts(...products, res);
        setPending(false);
        // console.log(concessions)
        
      });
    };

const [search,setSearch] = useState("");
const handleSearch = (event) => {
  setSearch(event.target.value); 
};
  return (
    <div className="w-full">
      <AddnExport />
      <Search updateList={handleSearch}/>
      <DataTable
        className="w-full rounded rounded-lg"
        columns={productColumns}
         data={products.filter((item) => {
          if (search === "") {
            return item;
          } else{
           return item.description.toLowerCase().includes(search.toLowerCase())||
           item.productName.toLowerCase().includes(search.toLowerCase())
           
          }
          })}
        progressPending={pending}
        pagination
      />
    </div>
  );
};

export default Products;
